import type { FaireProductEntity } from "../../entity_types/product";

export const p_5tq4vnmpc5: FaireProductEntity = {
  token: "p_5tq4vnmpc5",
  type: "product",
  name: "Women's Soft Plush Cozy Full Zip Lounge Robe",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/67b987fa9dd2baeaf75f9da2823114b0a6174583424aaca4fd186628ed29f7a8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/92752b4ce245fecb237d853fcdcefba5b6e124bb5d868c421ea8bac55878a4b5.jpeg",
    "https://cdn.faire.com/fastly/5a4fd5b8195de9edc5fb67b3b692166a9041332c730d0306ef3007717b7dbdb2.jpeg",
    "https://cdn.faire.com/fastly/4acd5330cc5f5b5713bdea6f5269965bd28610b903d4c6b0e32bb65c7c76c687.jpeg",
    "https://cdn.faire.com/fastly/029ce20fd85e158943de992fbc68e3635202ee8b215cde0da0c93b50a3a5e598.jpeg",
    "https://cdn.faire.com/fastly/0f40ccaf1c315664126cc16b5ebd808d9eb65da7b67d0a6b63e601adac7aac3b.jpeg",
    "https://cdn.faire.com/fastly/80af1e57bd1e5d55617719d5517073bfd390b7e31fa182ff9ce0ea0026a910d1.jpeg",
    "https://cdn.faire.com/fastly/1b088fc68dea9316618041d5c9a0c04941baa55cbc76f3f49db3f0287b7c9df6.png",
    "https://cdn.faire.com/fastly/91ffcd67210e18fdff20f8bf4b006e8b048cd4570dbca3e3900b12f774923a8a.jpeg",
    "https://cdn.faire.com/fastly/ae8e2f21ff275c00e6e1d2c89ec93a91948b4fe075b9b0c6943f10a18f5c2598.jpeg",
    "https://cdn.faire.com/fastly/234531add31fdf5a8a48662e3060128b9e531bafa47b5c9120bd28d269f4ab71.jpeg",
    "https://cdn.faire.com/fastly/8e73876b66219856c3cd9b2dc4c5b558c29a452a4eff71d68c07cfc90a7477cc.png"
  ],
  priceDollars: 60,
  description: "Cozy meets polished in the DreamPlush Zip Robe—a versatile essential made from our ultra-soft, velvety DreamPlush fabric. Designed with a full-length front zip, shawl collar, and relaxed silhouette, it wraps you in warmth whether you're lounging at home or layering up on the go. Elevated enough to wear as an overcoat, this robe brings luxurious comfort to both indoor and outdoor moments. A standout piece for gifting, resort edits, and cold-weather collections.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Relaxed, full-coverage fit with thoughtful structure\n• Full-length zipper for easy layering and secure comfort\n• Doubles as an overcoat for running errands or travel\n• Great for holiday gifting, spa collections, and cold-weather wardrobes\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬 & 𝐂𝐚𝐫𝐞:\n• Fabric: Made from ultra-soft, velvety DreamPlush fabric for a cozy, elevated feel\n• Fabric Content: 100% Polyester\n• Machine Washable\n• For best results: Turn inside out, wash cold, and line dry or tumble dry on low heat",
  tags: [],
  msrpDollars: 135,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:18.022Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
